import { render, staticRenderFns } from "./RegistrarPaciente.vue?vue&type=template&id=8c546e3c&"
import script from "./RegistrarPaciente.vue?vue&type=script&lang=js&"
export * from "./RegistrarPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports